import {Api} from "..";

class UrlRepository {
  public async getUrl(
    code: string,
    q?: string,
    s?: string,
    m?: string
  ): Promise<string | undefined> {
    return await Api.Redirection.getUrl(code, q, s, m);
  }
}

export default new UrlRepository();
